import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/components/AuthProvider';
import { LogIn, Loader2 } from 'lucide-react';

export const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const { signInWithGoogle } = useAuth();

  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      await signInWithGoogle();
    } catch (error) {
      console.error('Error logging in:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-xl sm:text-2xl font-bold">Đăng nhập hệ thống</CardTitle>
          <CardDescription className="text-sm sm:text-base">
            Sử dụng tài khoản Google để truy cập hệ thống báo cáo
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleGoogleLogin} 
            disabled={loading}
            className="w-full"
            size="lg"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            ) : (
              <LogIn className="h-4 w-4 mr-2" />
            )}
            Đăng nhập với Google
          </Button>
          
          <p className="text-center text-xs text-muted-foreground">
            Bằng việc đăng nhập, bạn đồng ý với{" "}
            <Link
              to="/privacy-policy"
              className="text-primary underline-offset-4 hover:underline"
            >
              Chính sách quyền riêng tư
            </Link>
            .
          </p>

          {/* Debug info for development */}
          <div className="text-xs text-gray-400 text-center space-y-1">
            <p>Environment: {window.location.hostname}</p>
            <p>User Agent: {navigator.userAgent.includes('Mobile') ? 'Mobile' : 'Desktop'}</p>
            <p>Screen: {window.innerWidth}x{window.innerHeight}</p>
            <p>Loading: {loading ? 'true' : 'false'}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
